import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { Card } from 'components/core/Card';
import { H2 } from 'components/core/Typography';
import { FacilityImageAndDetails } from 'components/facility/FacilityImageAndDetails';

import './SelectedFacilityCard.scss';

export function SelectedFacilityCard({
	facility, formattedPhoneNumber, unformattedPhoneNumber
}) {
	return (
		<Card className="selected-facility-card">
			<div className="divider">
				<H2
					size="medium"
				>
					Your storage facility
				</H2>
			</div>

			<FacilityImageAndDetails
				facilityUrl={facility.url.facility}
				image={get(facility, 'images[0]')}
				name={facility.name}
				location={facility.location}
				withStreetAddress
				formattedPhoneNumber={formattedPhoneNumber}
				unformattedPhoneNumber={unformattedPhoneNumber}
			/>
		</Card>
	);
}

SelectedFacilityCard.propTypes = {
	facility: PropTypes.object.isRequired,
	formattedPhoneNumber: PropTypes.string,
	unformattedPhoneNumber: PropTypes.string
};

export default SelectedFacilityCard;
